<template>
    <div>
        <public-title>房型动态</public-title>
        <div class="bg-white box-shadow p-3 load-area">
            <el-row>
                <el-col :span="21">
                    <el-tabs class="w-20" v-model="activeName">
                        <el-tab-pane label="推送采购商" name="2" />
                        <el-tab-pane name="3">
                            <label slot="label">推送酒店<span v-show="pushunread" class="unread"></span></label>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :span="3" class="text-right">
                    <div v-if="activeName == 2">
                        <div class="text-blue" v-if="infotime.travel_push_time || queryCon.name == 'hotel'">已推送</div>
                        <el-button type="primary" v-else size="small" @click="pushAll">开始推送采购商</el-button>
                    </div>
                    <div v-else>
                        <div class="text-blue" v-if="infotime.hotel_push_time || queryCon.name == 'travel'">已推送</div>
                        <el-button type="primary" v-else size="small" @click="pushAll">开始推送酒店</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-tabs v-if="activeName == '2'" v-model="activeChild2" type="card" class="mt-4 mb-5 childtab">
                <el-tab-pane label="系统匹配" name="first2" />
                <el-tab-pane label="指定推送" name="second2" />
            </el-tabs>
            <el-tabs v-else v-model="activeChild3" type="card" class="mt-4 mb-5 childtab">
                <el-tab-pane label="系统匹配" name="first3" />
                <el-tab-pane label="指定推送" name="second3" />
            </el-tabs>
            <div class="text-left mb-2">
                <label>共匹配{{activeName == '2' ? '采购商' : '酒店'}}：<span class="text-blue">{{AdminDataLists.total}}</span>&nbsp;家</label>
                <!-- <label>
                    通知成功<span class="text-success"> 2300 </span>家
                    通知失败<span class="text-danger"> 56 </span>家
                </label> -->
            </div>
            <div class="border rounded p-3 d-center-start flex-wrap" v-if="activeName == '2' && activeChild2 == 'second2'">
                <left-text-border class="w-50 mb-3" leftText="按名称" v-model="storeName"/>
                <left-text-select class="w-50 mb-3" leftText="认证状态" :options="$GVAR.verifyType" v-model="storeVerify"/>
                <select-city class="mb-3 w-90"
                    leftText="省市区"
                    mutiBlocks
                    @getCityInfo="info => this.cityInfo = info"
                    :provinceId="cityInfo.province"
                    :cityId="cityInfo.city"
                    :districtIds="cityInfo.district.map(v => v.id)"/>
                <div class="w-10 text-right mb-3">
                    <el-button type="primary" size="small" icon="el-icon-search" @click="getLists(storeName, storeVerify, '', '2')">搜索</el-button>
                </div>
            </div>
            <div class="border rounded p-3 d-center-start flex-wrap" v-if="activeName == '3' && activeChild3 == 'second3'">
                <left-text-border class="w-50 mb-3" leftText="按名称" v-model="storeName3"/>
                <left-text-select class="w-50 mb-3" leftText="认证状态" :options="$GVAR.verifyType" v-model="storeVerify3"/>
                <left-text-select class="w-50 mb-3" leftText="按星级" :options="$GVAR.HotelStar.slice(1,10)" v-model="storeStar" />
                <left-text-select class="w-50 mb-3" leftText="签约类型" :options="$GVAR.contractType" v-model="storeContract"/>
                <select-city class="mb-3 w-90"
                    leftText="省市区"
                    mutiBlocks
                    @getCityInfo="info => this.cityInfo3 = info"
                    :provinceId="cityInfo3.province"
                    :cityId="cityInfo3.city"
                    :districtIds="cityInfo3.district.map(v => v.id)"/>
                <div class="w-10 text-right mb-3">
                    <el-button type="primary" size="small" icon="el-icon-search" @click="getLists(storeName3, storeVerify3, '', '3')">搜索</el-button>
                </div>
            </div>
            <el-table
                v-show="activeName == 2"
                ref="multipleTravelTable"
                :data="TravelSelect"
                tooltip-effect="dark"
                style="width: 100%"
                @select="handleTravelChange"
                @select-all="handleTravelChange">
                <el-table-column type="selection" width="55" v-if="!infotime.travel_push_time" />
                <el-table-column type="index" width="50" label="序号" />
                <el-table-column prop="title" label="采购商名称" /> 
                <el-table-column label="省市区">
                    <template slot-scope="scope">{{scope.row.provinceName}} / {{scope.row.cityName}} / {{scope.row.districtName}}</template>
                </el-table-column>
                <el-table-column label="认证">
                    <template slot-scope="scope">
                        <div :class="[scope.row.verify==1?'text-success':'text-danger']">{{scope.row.verify | formatVar('verifyType')}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="签约类型" v-if="activeName == 3">
                    <template slot-scope="scope">
                        <div :class="[scope.row.contract > 0 ?'text-success':'text-danger']">{{scope.row.contract > 0 ? '已签约' : '未签约'}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-table
                v-show="activeName == 3"
                ref="multipleHotelTable"
                :data="HotelSelect"
                tooltip-effect="dark"
                style="width: 100%"
                @select="handleHotelChange"
                @select-all="handleHotelChange">
                <el-table-column type="selection" width="55" v-if="!infotime.hotel_push_time" />
                <el-table-column type="index" width="50" label="序号" />
                <el-table-column prop="title" label="酒店名称" />
                <el-table-column v-if="activeName == 3"  label="星级">
                    <template slot-scope="scope">{{scope.row.star | formatVar('HotelStar')}}</template>
                </el-table-column>
                <el-table-column label="省市区">
                    <template slot-scope="scope">{{scope.row.provinceName}} / {{scope.row.cityName}} / {{scope.row.districtName}}</template>
                </el-table-column>
                <el-table-column label="认证">
                    <template slot-scope="scope">
                        <div :class="[scope.row.verify==1?'text-success':'text-danger']">{{scope.row.verify | formatVar('verifyType')}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="签约类型" v-if="activeName == 3">
                    <template slot-scope="scope">
                        <div :class="[scope.row.contract > 0 ?'text-success':'text-danger']">{{scope.row.contract > 0 ? '已签约' : '未签约'}}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination layout="prev, pager, next" background class="mt-4"
            v-show="Number(AdminDataLists.total) > 0"
            :total=Number(AdminDataLists.total) :current-page="Number(queryCon.page)"
            @current-change="$GFUN.pageChange" />
    </div>
</template>

<script>
import { mapActions,mapState, mapMutations } from 'vuex'

export default {
    name: 'MatchList',
    data () {
        return {
            activeName: '2',
            activeChild2: 'first2',
            activeChild3: 'first3',
            current: 1,
            storeName: '',
            storeName3: '',
            storeStar:'',
            storeVerify:'',
            storeVerify3:'',
            storeContract:'',
            cityInfo:{
                province: '',
                city: '',
                district: []
            },
            cityInfo3:{
                province: '',
                city: '',
                district: []
            },
            TravelSelect: [],
            HotelSelect: [],
            allTravelSelect: [],
            allHotelSelect: [],
            multipleTravelTable: [],
            multipleHotelTable: [],
            localTravelId: [],
            localHotelId: [],
            pageSelectedArr: [],
            pageSelectedArr1: [],
            infotime: '',
            pushunread: true
        }
    },
    computed: {
        ...mapState(['AdminDataLists']),
        queryCon() { return this.$route.query },
    },
    watch:{
        queryCon() { this.getLists() },
        activeName (val) {
            this.pushunread = false
            this.$router.push({name,query:{...this.queryCon,page:1}})  
            if (val == '2') this.getLists(this.storeName, this.storeVerify)
            else this.getLists(this.storeName3, this.storeVerify3)
        },
        activeChild2 () {
            this.storeName = ''; this.storeVerify = ''; this.cityInfo = { province_name: '', city_name: '', province: '', city: '', district: [] }
            this.allTravelSelect = []; this.pageSelectedArr = []; this.getLists(this.storeName, this.storeVerify)
        },
        activeChild3 () {
            this.storeName3 = ''; this.storeVerify3 = ''; this.cityInfo3 = { province_name: '', city_name: '', province: '', city: '', district: [] };
            this.storeStar = ''; this.storeVerify = ''; this.allHotelSelect = []; this.pageSelectedArr1 = []; this.getLists(this.storeName3, this.storeVerify3)
        }
    },
    created () {
        this.current = Number(this.$route.query.page)
        if (this.queryCon.name == 'hotel') this.activeName = '3'
        else this.pushunread = false
        this.getLists()
    },
    methods: {
        ...mapMutations(['UPDATECURRENTSTORE']),
        ...mapActions(['getAdminDataLists']),
        // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
        getRowKey (row) { return row.id },
        getRowKey1 (row) { return row.id },
        handleTravelChange(selection,row) {
            this.pageSelectedArr[this.queryCon.page] = []
            if (null != selection && selection.length > 0) {
                this.pageSelectedArr[this.queryCon.page] = selection;
            }
        },
        handleHotelChange (selection,row) {
            this.pageSelectedArr1[this.queryCon.page] = []
            if (null != selection && selection.length > 0) {
                this.pageSelectedArr1[this.queryCon.page] = selection;
            }
        },
        /*获取酒店、景区、民宿列表*/
        getLists (name,verify,pushtime,search) {
            if (search == '2') {this.allTravelSelect = []; this.pageSelectedArr = []}
            else { this.allHotelSelect = [];this.pageSelectedArr1 = [] }
            this.UPDATECURRENTSTORE({type:Number(this.activeName)});
            let data = {
                name,
                storeType:Number(this.activeName),
                verify,
                pro:this.cityInfo.province,
                city:this.cityInfo.city,
                dis:this.cityInfo.district.map(v => v.id),
                room_state_push_time: pushtime
            }
            if (this.activeName == '3') { 
                data.star = this.storeStar, data.sign = this.storeContract,
                data.pro = this.cityInfo3.province,
                data.city = this.cityInfo3.city,
                data.dis = this.cityInfo3.district.map(v => v.id)
            }
            this.getAdminDataLists({
                type:'storeList',
                data,
                successFun: (res) => {
                    if (this.activeName == '2') {
                        this.TravelSelect = res.data
                        this.TravelSelect.forEach(v => this.allTravelSelect.push(v.id))
                        this.allTravelSelect = [...new Set(this.allTravelSelect)]
                        let toggArr = []; //勾选的
                        let tempData = this.pageSelectedArr[this.queryCon.page];
                        if (null != tempData && tempData.length > 0) {
                            for (let i = 0, n = tempData.length; i < n; i++) {
                                for (let j = 0, m = this.TravelSelect.length; j < m; j++) {
                                    if (tempData[i].id == this.TravelSelect[j].id) {
                                        toggArr.push(this.TravelSelect[j]);
                                    }
                                }
                            }
                        }
                        if (toggArr.length > 0) {
                            this.$nextTick(_ =>{
                                toggArr.forEach(row => {
                                    this.$refs.multipleTravelTable.toggleRowSelection(row);
                                });
                            })
                        } else {
                            this.$nextTick(_ => {
                                this.TravelSelect.forEach(row =>{
                                    this.$refs.multipleTravelTable.toggleRowSelection(row);
                                })
                            })
                        }
                    } else {
                        this.HotelSelect = res.data
                        this.HotelSelect.forEach(v => this.allHotelSelect.push(v.id))
                        this.allHotelSelect = [...new Set(this.allHotelSelect)]
                        let toggArr1 = [];
                        let tempData1 = this.pageSelectedArr1[this.queryCon.page];
                        if (null != tempData1 && tempData1.length > 0) {
                        for (let i = 0, n = tempData1.length; i < n; i++) {
                            for (let j = 0, m = this.HotelSelect.length; j < m; j++) {
                                if (tempData1[i].id === this.HotelSelect[j].id) {
                                        toggArr1.push(this.HotelSelect[j]);
                                    }
                                }
                            }
                        }
                        this.localHotelId = toggArr1
                        if (toggArr1.length > 0) {
                            this.$nextTick(_ =>{
                                toggArr1.forEach(row => {
                                    this.$refs.multipleHotelTable.toggleRowSelection(row);
                                });
                            })
                        } else {
                            this.$nextTick(_ => {
                                this.HotelSelect.forEach(row =>{
                                    this.$refs.multipleHotelTable.toggleRowSelection(row);
                                })
                            })
                        }
                    }
                }
            });
        },
        //推送
        pushAll () {
            this._confirm('确定推送么？',() => { this.push() })
        },
        async push () {
            if (this.pageSelectedArr.length > 0) {
                let travelid = []
                this.pageSelectedArr.forEach(ele => {
                    ele.forEach(v => travelid.push(v.id))
                })
                this.localTravelId = this.allTravelSelect.filter(item=>travelid.indexOf(item)==-1)
            }
            if (this.pageSelectedArr1.length > 0) {
                let hotelid = []
                this.pageSelectedArr1.forEach(ele => {
                    ele.forEach(v => hotelid.push(v.id))
                })
                this.localHotelId = this.allHotelSelect.filter(item=>hotelid.indexOf(item)==-1)
            }
            let data = {
                push_store_id: '',
                cancel_store_id: '',
                cancel_hotel_id: '',
                room_state_id: this.$route.query.id,
                push_type: this.activeName,
                sort: this.$route.query.id
            }
            if (this.queryCon.time == 'session') {
                data.room_state_id = sessionStorage.getItem('settime')
                data.sort = sessionStorage.getItem('sort')
            }
            if (this.activeChild2 == 'second2') {
                data.travel_title = this.storeName,
                data.travel_verify = String(this.storeVerify),
                data.travel_province = this.cityInfo.province,
                data.travel_city = this.cityInfo.city,
                data.travel_district = this.cityInfo.district.map(v => v.id).join(',')
            }
            if (this.activeChild3 == 'second3') {
                data.hotel_title = this.storeName3,
                data.hotel_verify = String(this.storeVerify3),
                data.hotel_province = this.cityInfo3.province,
                data.hotel_city = this.cityInfo3.city,
                data.hotel_district = this.cityInfo3.district.map(v => v.id).join(',') 
                data.hotel_star = this.storeStar; data.hotel_contract = this.storeContract 
            }
            if (this.localTravelId.length == 0 && this.localHotelId.length == 0) { data.push_store_id = 'all' }
            else {
                data.cancel_store_id = this.localTravelId.join(',')
                data.cancel_hotel_id = this.localHotelId.join(',')
            }
            let res = await this.$axios.post('/pc/Admin/pushRoomState',data);
            if (res.code === '00000') {
                this.$message.success('推送成功！')
                this.$router.push({name: 'PushRecord'})
                this.infotime = res.info
                this.getLists('', '', res.info)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.childtab{
    width: 195px;
}
.unread{
    position: absolute;
    width: 10px;
    height: 10px;
    background: #dc3545;
    border-radius: 50%;
    left: 80px;
    top: 10px
}
</style>
